import { VulnerabilitiesSideMenuWebComponent } from './component/VulnerabilitiesSideMenuWebComponent';

export { VulnerabilitiesSideMenuWebComponent };
